module.exports = __webpack_public_path__ + "assets/img/bg_pc2.01cc1661.jpg";